import { useEndpoint } from '@apparatix/composables';
import type { ApiResponseBase } from '@apparatix/types/Documents';
import type { OfferHoldHistoryEntry, OfferHoldThruResponse, OfferManagementResponse } from '@apparatix/types/OfferManagement';

export const useOfferManagement = () => {
  const offersEndpoint = useEndpoint<ApiResponseBase<OfferManagementResponse>>({
    url: '/crm/offer-management/filter', type: 'POST', successField: 'data', toast: { showOnSuccess: false },
  });
  const holdThruEndpoint = useEndpoint<ApiResponseBase<OfferHoldThruResponse>>({
    type: 'PUT', successField: 'data', toast: { showOnSuccess: false },
  });

  const holdHistoryEndpoint = useEndpoint<ApiResponseBase<{ history: OfferHoldHistoryEntry[] }>>({
    type: 'GET', successField: 'data', toast: { showOnSuccess: false },
  });

  const loadOffers = async (context: Record<string, string>) => {
    const response = await offersEndpoint.getResults({ context });
    return response?.data ?? null;
  };

  const updateHoldThru = async (proposalId: number, holdThru: string | null, context: Record<string, string>) => {
    holdThruEndpoint.setEndpointUrl(`/crm/offer-management/${proposalId}/hold-thru`);
    const response = await holdThruEndpoint.getResults({ holdThru, context });
    return response?.data ?? null;
  };

  const loadHoldHistory = async (proposalId: number, context: Record<string, string>) => {
    const query = new URLSearchParams(Object.entries(context).map(([key, value]) => [`context[${key}]`, value])).toString();
    holdHistoryEndpoint.setEndpointUrl(`/crm/offer-management/${proposalId}/hold-history${query ? `?${query}` : ''}`);
    const response = await holdHistoryEndpoint.getResults();
    return response?.data.history ?? null;
  };

  return {
    isLoadingHoldHistory: holdHistoryEndpoint.isLoading,
    loadHoldHistory,
    isSavingHoldThru: holdThruEndpoint.isLoading,
    loadOffers,
    updateHoldThru,
  };
};
